import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static outlets = ['containers--dialog-container'];

  openDialog() {
    this.containersDialogContainerOutlet.open();
  }
}
